//
export function calcScorePercValues(score: any) {
    score.visualPerc = Math.round((score.visual / 81328) * 100);
    score.powerPerc = Math.round((score.power / 81586) * 100);
    score.genePerc = Math.round((score.gene / 81920) * 100);
    score.totalPerc = Math.round((score.total / 74569) * 100);
}